import type { InstrumentNode, PatchDocument } from "../domain/patch";
import type { SynthDocument } from "../synth-designer/document";
import { grandmotherDocument, matriarchDocument } from "./native-documents";

export type InstrumentBundle = {
  document: SynthDocument;
};

export const instrumentCatalog: readonly InstrumentBundle[] = [
  { document: grandmotherDocument },
  { document: matriarchDocument },
];

const bundlesByDefinitionId = new Map(
  instrumentCatalog.map((bundle) => [bundle.document.id, bundle]),
);

export function primaryInstrumentNode(document: PatchDocument): InstrumentNode | undefined {
  return document.workspace.nodes.find(
    (node): node is InstrumentNode => node.kind === "instrument",
  );
}

export function instrumentBundleByDefinitionId(definitionId: string | undefined) {
  return definitionId ? bundlesByDefinitionId.get(definitionId) : undefined;
}

export function instrumentBundleForDocument(document: PatchDocument): InstrumentBundle {
  const node = primaryInstrumentNode(document);
  return instrumentBundleByDefinitionId(node?.definitionId) ?? instrumentCatalog[0]!;
}

export function synthDocumentByDefinitionId(definitionId: string) {
  return instrumentBundleByDefinitionId(definitionId)?.document;
}
